require('./expensesSummaryBoxList.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
import { connect } from 'react-redux';

// @components
const { OKLink } = require('commonsComponents/OKLink');
const { Link } = require('react-router-dom');
const { EmptyState } = require('commonsComponents/emptyState');
const  ExpensesSummaryBoxRow = require('../expensesSummaryBoxRow/expensesSummaryBoxRow');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ actions
import { initSelectFilter } from 'actions/filters'

// @ constants
const { ALL_CATEGORIES, CATEGORY } = require('constants/expensesByCategories/filters');
const { PFM_FILTERS } = require('constants/index');



const ExpensesSummaryBoxList = ({ currency, currentValues, isFiltersApplied, prevValues, initSelectFilter } ) => {

    const buildEmptyState = (isFiltersApplied, isFilterComparing) => {
        let noExpensesMessage = 'myGlobalPositionExpenses-defaultNoExpensesMessage';
        if (isFiltersApplied) {
            noExpensesMessage = isFilterComparing? 'myGlobalPositionExpenses-noExpensesMessageWithCompare' : 'myGlobalPositionExpenses-noExpensesMessageWithFilter';
        }

        const message  = formatText(noExpensesMessage);

        return (
            <div className="expenses-summary-box__list__empty-state text-center">
                <EmptyState primaryText={message} textRegular iconType="noitems-banking"/>
                <OKLink inverse to="/myprofile/global/expenses-by-category/" >
                    <FormattedText value="myGlobalPositionExpenses-showBreakdown" />
                </OKLink>
            </div>
        );
    }

    const handleOnClick = (categoryCode) => {
        initSelectFilter(PFM_FILTERS, CATEGORY, true, categoryCode, ALL_CATEGORIES, 'selectorFilter', formatText(`categorized-category_${categoryCode}`), null, false);
    }

    const buildSummaryList= (values, prevValues, currency) => {
        const categoriesOnList = values.slice(0, 5);
        const categoriesOnListPrev = !!prevValues && prevValues.filter((cat)=> categoriesOnList.find(item => item[0] === cat[0]));
        const maxExpenses = () => prevValues && prevValues.length > 0? Math.max(values[0][1], categoriesOnListPrev[0][1]): values[0][1];
        const list = categoriesOnList.map( (category, i) => {

            return (
                <Link className="expenses-summary-box__list__row--link" expenses-by-category onClick={() => handleOnClick(category[0])} key={i} >
                    <li className="expenses-summary-box__list__row" > 
                        <ExpensesSummaryBoxRow category={category} prevValues={prevValues} maxExpenses={maxExpenses} currency={currency}/>
                    </li>
                </Link>
            )
        });
        return list;
    };

    const buildSummary = () => {
        return(
            <ul className="expenses-summary-box__list">
                {buildSummaryList(currentValues, prevValues, currency)}
            </ul>
        );
    };

    const content = currentValues.length <= 0 ? buildEmptyState(isFiltersApplied) : buildSummary();

    return content;
}

ExpensesSummaryBoxList.propTypes = {
    currentValues: PropTypes.arrayOf(PropTypes.array),
    prevValues: PropTypes.arrayOf(PropTypes.array),
    currency: PropTypes.string,
    isFiltersApplied: PropTypes.bool,
    initSelectFilter: PropTypes.func,
};

export default connect(null, {
    initSelectFilter,
})(ExpensesSummaryBoxList);